export const get_account_balance = `query get_account_balance($account: String!, $currency: String!){
    get_account_balance(account: $account, currency: $currency){
        balance
        investable
        daytrade_limit
    }
}`;
